<template>
  <div>
    <div
      :class="{'has-padding': isShowFooter && !showingTypeAnswerInput
        && !presentation.isReactionEnabled}"
    >
      <div v-if="!showingTypeAnswerInput">
        <div
          class="sub-header"
          v-if="$store.state.slide.multipleChoice
            && $store.state.slide.SlideOptions.length > 1
            && $store.state.slide.type != 'pickAnswer'"
        >
          {{ $t("multipleChoiceInstruction") }} {{ $store.state.slide.limitChoice }} {{ $t("options") }}.
        </div>

        <div
          class="sub-header"
          v-if="$store.state.slide.multipleChoice
            && $store.state.slide.SlideOptions.length > 1
            && !this.$store.state.slide.isCorrectGetPoint
            && $store.state.slide.type == 'pickAnswer'"
        >
          {{ $t("quizYouMustPickAll") }}
        </div>
        <div
          class="sub-header"
          v-if="$store.state.slide.multipleChoice
            && $store.state.slide.SlideOptions.length > 1
            && this.$store.state.slide.isCorrectGetPoint && $store.state.slide.type == 'pickAnswer'"
        >
          {{ $t("mustNotPickIncorrectAnswer") }}
        </div>

        <div
          class="sub-header"
          v-if="!$store.state.slide.multipleChoice
            && $store.state.slide.type == 'pickAnswer' && checkAnyCorrectAnswer() > 1"
        >
          {{ $t("youCanPickAnyCorrectAnswer") }}
        </div>
      </div>
      <Masonry masonry-id="slide-option-masonry" v-if="viewType === 'image'">
        <MasonryItem
          :key="slideOption.id"
          v-for="slideOption in slideOptions"
        >
          <Option
            variant="image"
            :id="slideOption.id"
            :title="slideOption.title"
            :image="slideOption.imageCropped"
            :multiple-select="slide.multipleChoice"
            @handle-image-load="redrawMasonryById('slide-option-masonry')"
            v-model="submittedAnswer"
            :correct="slideOption.correct"
            :disabled="result.id && $store.state.slide.quizStatus >= QuizStatuses.QUESTION_SCREEN"
            :show-result="canShowQuizResult"
            :show-number-of-same-answer="optionQuizResult !== null"
            :number-of-same-answer="optionQuizResult && optionQuizResult[slideOption.id]"
            :text-colour="slide.textColour"
            :is-waiting-quiz-result="isWaitingQuizResult"
            :base-colour="slide.baseColour"
          />
        </MasonryItem>
      </Masonry>

      <template v-if="viewType === 'text'">
        <Option
          :id="slideOption.id"
          v-for="slideOption in slideOptions"
          :base-colour="slide.baseColour"
          :text-colour="slide.textColour"
          variant="text"
          :key="slideOption.id"
          :title="slideOption.title"
          :image="slideOption.imageCropped"
          :multiple-select="slide.multipleChoice"
          v-model="submittedAnswer"
          :correct="slideOption.correct"
          :disabled="result.id && $store.state.slide.quizStatus >= QuizStatuses.QUESTION_SCREEN"
          :show-result="canShowQuizResult"
          :show-number-of-same-answer="optionQuizResult !== null"
          :is-waiting-quiz-result="isWaitingQuizResult"
          :number-of-same-answer="optionQuizResult && optionQuizResult[slideOption.id]"
        />
      </template>

      <CorrectOrderContent
        v-if="viewType === 'correctOrder'"
        :result="result"
        :is-quiz-submitted="isAnswerSubmitted"
        @updateCorrectOrderAnswer="updateCorrectOrderAnswer"
        :is-waiting-quiz-result="isWaitingQuizResult"
      />
      <MatchPairsContent
        v-if="viewType === 'matchPairs'"
        :result="result"
        :is-form-submitted="isAnswerSubmitted"
        :is-waiting-quiz-result="isWaitingQuizResult"
      />

      <div v-if="showingTypeAnswerInput">
        <TypeAnswerQuizInput
          v-if="!isEmptyTypeAnswerAfterTimesUp"
          :is-waiting-quiz-result="isWaitingQuizResult"
          class="type-answer-input"
          :type="typeAnswerResultType"
          :display-user-count="!!optionQuizResult"
          :number-of-user-with-same-answer="optionQuizResult &&
            optionQuizResult[typeAnswerValue.toLowerCase()]"
          v-model="typeAnswerValue"
          @enterKey="submit"
        />

        <div v-if="showingCorrectTypeAnswerInput">
          <p class="type-anwwer-correct-text">
            {{ $t('correctAnswerTitle') }}
          </p>
          <TypeAnswerQuizInput
            v-if="correctTypeAnswer"
            class="type-answer-input show-correct-answer-input"
            type="showCorrectAnswer"
            :value="correctTypeAnswer"
            :display-user-count="!!optionQuizResult"
            :number-of-user-with-same-answer="optionQuizResult &&
              optionQuizResult[correctTypeAnswer.toLowerCase()]"
          />
          <p
            class="type-answer-no-correct-answer"
            v-else
          >
            {{ $t('noCorrectAnswer') }}
          </p>
        </div>
        <div v-if="showingOtherCorrectTypeAnswerInput">
          <p class="type-anwwer-correct-text">
            {{ $t('alsoAccepted') }}
          </p>
          <TypeAnswerQuizInput
            v-for="item in $store.state.slide.otherCorrectQuiz"
            :key="item.id"
            class="type-answer-input type-answer-input--others"
            type="showOtherCorrectAnswer"
            :value="item.title || ''"
            :display-user-count="!!optionQuizResult"
            :number-of-user-with-same-answer="optionQuizResult &&
              optionQuizResult[item.title && item.title.toLowerCase()]"
          />
        </div>
      </div>
    </div>

    <QuizFormSubmitButton
      v-if="canShowSubmitButton"
      :disabled="isDisabledSubmitButton"
      :time-answer="Number(result.timeAnswer)"
      :time-to-answer="Number(slide.timeToAnswer)"
      :is-form-submitted="isAnswerSubmitted"
      :is-waiting-quiz-result="isWaitingQuizResult"
      @submit="submit"
    />

    <div
      class="quiz-result"
    >
      <QuizResult
        v-if="canShowQuizResult && result && result.id"
        :class="{
          show: isShowFooter,
        }"
        :result="result"
        :teamPlay="teamPlay"
        :teamQuizResult="teamQuizResult"
      />
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

// event bus
import EventBus from '@/eventBus'

// configs
import Config from '@/config'

// utils
import utils from '@/util'

// storage
import storage from '@/services/storage'

// 3rd parties
import sentry from '@/3rd-parties/sentry'

import UserIsTypingMixin from '@/mixins/UserIsTypingMixin'
import PreloadImageMixin from '@/mixins/PreloadImageMixin.vue'

// components
import QuizStatuses from '@/constants/QuizStatuses'
import TypeAnswerQuizInput from './TypeAnswerQuizInput.vue'
import QuizFormSubmitButton from './QuizFormSubmitButton.vue'
import Option from './Option.vue'
import Masonry, { masonryMixin } from '../masonry/Masonry.vue'
import MasonryItem from '../masonry/MasonryItem.vue'
import MatchPairsContent from './MatchPairsContent.vue'
import CorrectOrderContent from './CorrectOrderContent.vue'
import QuizResult from './QuizResult.vue'

export default {
  components: {
    Option,
    Masonry,
    MasonryItem,
    TypeAnswerQuizInput,
    QuizFormSubmitButton,
    MatchPairsContent,
    CorrectOrderContent,
    QuizResult,
  },
  mixins: [masonryMixin, UserIsTypingMixin, PreloadImageMixin],
  props: {
    result: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      isShowFooter: false,
      timeLeft: 0,
      submittedAnswer: null,
      typeAnswerValue: this.result.typeAnswer || '',
      correctTypeAnswer: '',
      optionQuizResult: null,
      teamQuizResult: {},
      correctOrderAnswer: null,
      isAnswerSubmitted: false,
    }
  },

  computed: {
    ...mapGetters(['isWaitingQuizResult', 'canShowQuizResult']),
    ...mapState({
      audienceId: (state) => state.audienceId,
      slide: (state) => state.slide,
      slideOptions: (state) => {
        const slideOptions = state.slide.SlideOptions.filter((item) => {
          return item.title || item.image || item.imageCropped
        })

        if (state.presentation.areSlideOptionsShuffling) {
          return utils.shuffleArrayWithSeed(slideOptions, state.audienceId.charCodeAt(0))
        }

        return slideOptions
      },
      teamPlay: (state) => state.presentation.teamPlay,
      audienceQuizTeam: (state) => state.audienceQuizTeam,
      presentation: (state) => state.presentation,
      isEnableStreakBonus: (state) => state.presentation.isEnableStreakBonus,
    }),
    viewType() {
      // TODO: need to refactor for more meaningful name: e.g: quizType()

      if (this.slide.type === 'pickAnswer' && this.slide.slideType === 'imageChoice') {
        try {
          if (this.slide.SlideOptions.length && this.slide.SlideOptions.some((item) => item.image || item.imageCropped)) {
            return 'image'
          }
          return 'text'
        } catch {
          // do nothing
        }
        return 'image' // Quiz: image choice
      }
      if (this.slide.type === 'pickAnswer' && this.slide.slideType == null) {
        return 'text' // Quiz: pick answer
      }

      if (this.slide.type === 'pickAnswer' && this.slide.slideType === 'matchPairs') {
        return 'matchPairs'
      }

      if (this.slide.type === 'pickAnswer' && this.slide.slideType === 'correctOrder') {
        return 'correctOrder'
      }

      return 'type' // Quiz: type answer
    },

    showingTypeAnswerInput() {
      return this.viewType === 'type'
    },

    isStickySubmitButton() {
      return this.slide.type === 'pickAnswer' && (this.slide.slideType === 'typeAnswer' || this.slide.slideType === 'correctOrder')
    },

    showingCorrectTypeAnswerInput() {
      return this.result && !this.result.correct && this.canShowQuizResult
    },

    showingOtherCorrectTypeAnswerInput() {
      return this.result
        && this.canShowQuizResult
        && this.slide.otherCorrectQuiz
        && this.slide.otherCorrectQuiz.length
    },

    isEmptyTypeAnswerAfterTimesUp() {
      return this.canShowQuizResult && !this.typeAnswerValue
    },

    isDisabledSubmitButton() {
      if (this.result &&
        (this.result.timeAnswer === this.slide.timeToAnswer || this.result.timeout)) {
        return true
      }

      if (this.slide.slideType === 'correctOrder') {
        return false
      }

      if (this.slide.slideType === 'matchPairs') {
        return !this.slide.SlideOptions.some((item) => item.pairSelected)
      }

      return !this.submittedAnswer && (
        !this.typeAnswerValue ||
        (this.typeAnswerValue && !this.typeAnswerValue.trim()))
    },

    canShowSubmitButton() {
      const isQuestionScreen = this.slide.quizStatus === QuizStatuses.QUESTION_SCREEN
        || this.slide.quizStatus === QuizStatuses.RESULT_SCREEN
      if (!this.presentation.manualRevealCorrectAnswers
        || this.presentation.audiencePacing) return isQuestionScreen
      const isResultScreen = this.slide.quizStatus === QuizStatuses.RESULT_SCREEN

      return isQuestionScreen || (isResultScreen && !this.slide.showCorrectOption)
    },
    canShowResultButton() {
      if (!this.teamPlay) {
        return this.result && (this.result.id || this.result.notPlay)
      }
      return this.teamQuizResult && this.teamQuizResult.loaded
    },
    isResultSceneHasResult() {
      return this.result && this.result.id && this.canShowQuizResult
    },
    typeAnswerResultType() {
      if (this.isAnswerSubmitted) return 'disabled'
      if (this.isResultSceneHasResult && this.result.correct) return 'correct'
      if (this.isResultSceneHasResult && !this.result.correct) return 'incorrect'
      return ''
    },
  },

  watch: {
    'slide.quizStatus': function changeStatus(quizStatus) {
      if (quizStatus === 5) {
        this.getQuizResult()
      }
    },
    'slide.showCorrectOption': function changeShowCorrectOption(showCorrectOption) {
      if (showCorrectOption) {
        this.getQuizResult()
      }
    },
  },

  created() {
    this.QuizStatuses = QuizStatuses
  },

  mounted() {
    setTimeout(() => {
      // Because <QuizForm> is placing inside <transition> component
      // and the Footer is position-fixed,
      // The footer is flicked when transiting to the question screen.
      // Delay showing the Footer will fix this issue.
      this.isShowFooter = true
    }, 300)
    // get correct type answer
    if (this.$store.state.slide.slideType === 'typeAnswer') {
      if (this.$store.state.slide.correctQuizTypeAnswer) {
        this.correctTypeAnswer = this.$store.state.slide.correctQuizTypeAnswer
      } else if (
        this.$store.state.slide.otherCorrectQuiz &&
        this.$store.state.slide.otherCorrectQuiz.length
      ) {
        this.$store.state.slide.otherCorrectQuiz.forEach((item) => {
          if (item.title && !this.correctTypeAnswer) {
            this.correctTypeAnswer = item.title
          }
        })
      }
    }

    if (this.result && this.result.id) {
      this.submittedAnswer = this.result.vote
      this.isAnswerSubmitted = true
    }

    if (this.slide.quizStatus === 5) {
      this.getQuizResult()
    }
  },
  destroyed() {
    this.isShowFooter = false
  },
  methods: {
    _isValidPair(option) {
      return option.title && option.pairTitle
    },
    getMatchPairsAnswer() {
      const answers = []
      this.slide.SlideOptions.forEach((option) => {
        if (this._isValidPair(option)) {
          answers.push({
            prompt: option.id,
            answer: option.pairSelected && option.pairSelected.id,
          })
        }
      })
      return answers
    },

    updateCorrectOrderAnswer(answer) {
      this.correctOrderAnswer = answer
    },

    getCorrectOrderAnswer() {
      return this.correctOrderAnswer.map((item) => item.id)
    },

    async submit() {
      if (this.isAnswerSubmitted) {
        return
      }

      storage.updateValueByPresentation(this.presentation.id, 'audienceId', this.audienceId)
      this.error = ''
      const payload = {
        presentation: this.$store.state.presentation.id,
        slide: this.slide.id,
        audience: this.audienceId,
        accessCode: this.$store.state.presentation.uniqueAccessCode,
        slideTimestamp: this.slide.slideTimestamp,
        config: {
          timeToAnswer: this.slide.timeToAnswer,
          // quizTimestamp: this.slide.quizTimestamp, old code: linh vu sentry log
          // new code: hainh replace computed to global state
          quizTimestamp: this.$store.state.slide.quizTimestamp,
          multipleChoice: this.slide.multipleChoice,
          isCorrectGetPoint: this.slide.isCorrectGetPoint,
          stopSubmission: this.slide.stopSubmission,
          fastAnswerGetMorePoint: this.slide.fastAnswerGetMorePoint,
          otherCorrectQuiz: this.slide.otherCorrectQuiz,
          correctQuizTypeAnswer: this.slide.correctQuizTypeAnswer,
          maxPoint: this.slide.maxPoint,
          minPoint: this.slide.minPoint,
          quizToken: this.slide.quizToken,
          SlideOptions: this.slide.SlideOptions.map((dataOption) => {
            return {
              id: dataOption.id,
              correct: dataOption.correct,
              order: dataOption.order,
            }
          }),
        },
        type: this.slide.type,
        slideType: this.slide.slideType,
        streakRelatedInfo: {
          isEnableStreakBonus: this.isEnableStreakBonus,
          teamPlay: this.teamPlay,
        },
      }

      if (this.presentation.audiencePacing) {
        payload.config.audiencePacingTimeAnswer = new Date().getTime() - this.slide.quizTimestamp
      }

      if (this.slide.slideType === 'typeAnswer') {
        payload.typeAnswer = this.typeAnswerValue
        if (!payload.typeAnswer.trim()) {
          return
        }
        payload.vote = []
      } else if (!this.$store.state.slide.multipleChoice) {
        payload.vote = [this.submittedAnswer]
      } else {
        payload.vote = this.submittedAnswer
      }

      if (this.slide.slideType === 'matchPairs') {
        payload.vote = []
        payload.pairs = this.getMatchPairsAnswer()
      }

      if (this.slide.slideType === 'correctOrder') {
        payload.vote = []
        payload.pairs = this.getCorrectOrderAnswer()
      }

      payload.audienceName = this.$store.state.audienceName
      payload.audienceEmoji = this.$store.state.audienceEmoji
      EventBus.$emit('quiz-stop-submit')
      EventBus.$emit('stop-progress-bar-quiz')
      EventBus.$emit('cancelAnimationFrame')

      if (this.$store.state.presentation.teamPlay) {
        payload.audienceTeam = this.$store.state.audienceQuizTeam
      }
      this.isAnswerSubmitted = true

      // Sẽ lưu lại flag này, tránh trường hợp slow internet dẫn tới chưa nhận được response api này mà lại nhận được socket timeup
      this.$store.state.isSlideAnswerSubmitting[this.$store.state.slide.id] = true

      try {
        if (payload.type === 'pickAnswer') {
          if (!payload.config.quizTimestamp || payload.config.quizTimestamp.length === 0) {
            sentry.captureException('Invalid quizTimestamp', {
              extra: {
                file: 'QuizForm.vue',
                description: 'bo sung quiz timestamp vao data',
                payload,
                quizTimestamp: payload.config.quizTimestamp,
                slide: this.$store.state.slide,
              },
            })
          }
        }
      } catch {
        // do nothing
      }

      try {
        const res = await this.$http.post(Config.api.createAnswer, payload)

        this.$store.state.isSlideAnswerSubmitting[this.$store.state.slide.id] = undefined

        res.body.timeAnswer = parseFloat(res.body.timeAnswer)
        this.timeLeft = this.$store.state.slide.timeToAnswer - res.body.timeAnswer
        this.timeLeft = parseFloat(this.timeLeft)
        EventBus.$emit('quiz-waiting-result', {
          timeAnswer: res.body.timeAnswer,
          timeLeft: this.timeLeft,
          answer: res.body,
          notSubmit: true,
        })

        const presentationId = this.$store.state.presentation.id
        const answeredSlideIds = storage.getValueByPresentation(presentationId, 'answeredSlideIds', [])
        answeredSlideIds.push(this.$store.state.slide.id)
        storage.setValueByPresentation(presentationId, 'answeredSlideIds', answeredSlideIds)
        if (this.presentation.audiencePacing) {
          window.setTimeout(() => {
            this.$store.dispatch('updateSlide', {
              quizStatus: 5,
            })
          }, 2e3)
        }
        utils.mixpanelTrack(
          'Audience > Quiz',
          'Submit answer',
          'Audience Submit Answer',
        )
      } catch (error) {
        this.$store.state.isSlideAnswerSubmitting[this.$store.state.slide.id] = undefined

        if (error.body && error.errorCode === 411) {
          this.error = this.$t('submissionClosedButton')
        } else {
          this.error = this.$t('openendedSubmissionFail')
          let quizTimestamp = null
          if (payload.config) {
            quizTimestamp = payload.config.quizTimestamp
          }
          sentry.captureException('Error when creating answer', {
            extra: {
              file: 'QuizForm.vue',
              payload,
              payloadQuizTimestamp: quizTimestamp,
              slide: this.$store.state.slide,
              errorMessage: error.message,
              stackTrace: error.stack,
              errorFull: error,
              errorCode: error.errorCode,
            },
          })
        }
        utils.mixpanelTrack(
          'Multiple Choice Submit',
          'Audience submit fail',
          JSON.stringify(error),
        )
      } finally {
        this.setUserTypingEnd()
      }
    },
    getQuizResult() {
      if (this.presentation.manualRevealCorrectAnswers
        && !this.presentation.audiencePacing && !this.slide.showCorrectOption) return
      if (this.slide.quizResultCache) {
        this.$http.get(this.slide.quizResultCache).then((res) => {
          this.normalizeTeamQuizResult(res.body.teams)
          this.optionQuizResult = this.lowerCaseOptionKey(res.body.options)
        },
        () => {})
      } else {
        this.$http.get(Config.api.slideQuizResult + this.slide.id).then((res) => {
          this.normalizeTeamQuizResult(res.body.teams)
          this.optionQuizResult = this.lowerCaseOptionKey(res.body.options)
        },
        () => {})
      }
    },
    lowerCaseOptionKey(options) {
      return Object.keys(options)
        .filter((k) => !!k)
        .map((k) => ({ [k.toLowerCase()]: options[k] }))
        .reduce((item, agg) => ({ ...item, ...agg }), {})
    },
    normalizeTeamQuizResult(teamQuizResult) {
      if (teamQuizResult) {
        this.teamQuizResult = teamQuizResult
        if (!Object.keys(teamQuizResult).length) {
          this.teamQuizResult.noData = true
        }
      } else {
        this.teamQuizResult.noData = true
      }
      this.teamQuizResult.loaded = true
    },
    checkAnyCorrectAnswer() {
      let count = 0
      if (!this.$store.state.slide.SlideOptions) return count
      this.$store.state.slide.SlideOptions.forEach((item) => {
        if (item.correct) {
          count++
        }
      })
      return count
    },
  },

}
</script>

<style lang="scss" scoped>
.sub-header {
  text-align: center;
  margin-top: 16px;
  margin-bottom: 16px;
  padding: 0 16px 0 16px;
  opacity: 0.7;
}
.type-anwwer-correct-text {
  font-size: 14px;
  font-weight: 700;
  margin-bottom: 12px;
  text-align: left;
}

.type-answer-no-correct-answer {
  text-align: left;
}

.type-answer-input {
  margin-bottom: 28px;
  &--others {
    margin-bottom: 10px;
  }
}

.quiz-footer {
  display: none;
  width: 100%;
  z-index: 100;
  filter: drop-shadow(0 -4px 39px rgba(0,0,0,0.15));
  &.show {
    display: block;
  }
  &.sticky {
    transition: all 0.3s ease;
    position: fixed;
    bottom: 0;
    left: 0;
    .quiz-footer--content {
      padding: 16px;
    }
  }
  &.type-answer__footer {
    margin-top: 32px;
  }
}

.quiz-footer--content {
  max-width: 710px;
  width: 100%;
  margin: 0 auto;
}

.has-padding {
  padding-bottom: 120px;
}
.animation-text {
  animation: show-height 1s;
  overflow: hidden;
}

@keyframes show-height {
  0% {
    max-height: 0;
  }
  100% {
    max-height: 500px;
  }
}

.quiz-result {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  z-index: 1;

  &-content {
    padding: 12px 16px;
  }
  filter: drop-shadow(0px -4px 14px rgba(0, 0, 0, 0.10));
}
</style>
